import { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BsArrowLeftShort } from "react-icons/bs";
import Input from "../../components/elements/form/Input";
import Checkbox from "../../components/elements/form/Checkbox";
import H2 from "../../components/elements/titles/H2";
import Paragraph from "../../components/elements/p/Paragraph";
import Button from "../../components/elements/buttons/ButtonAction";
import { firebaseSignInAdmin } from "../../api/admins/adminApi";
import currentAdminContext from "../../dataManager/context/currentAdminContext";
import { toast } from "react-toastify";

const BodyLoginAdmin = () => {
  const navigate = useNavigate();

  //context variables
  const { currentAdmin, login } = useContext(currentAdminContext);

  //state variable
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // some handlers
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");

    //login admin
    const { data, error } = await firebaseSignInAdmin(email, password);

    if (error) {
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentAdmin && currentAdmin.role === 1) {
      //stop loading
      setLoading(false);

      console.log({ currentAdmin });

      //redirect to admin darshboard
      navigate("/admin");

      toast.success(
        `Bienvenue dans votre interface d'administration mr ${currentAdmin.getName}`
      );
    }
  }, [currentAdmin]);

  return (
    <>
      <form
        onSubmit={(e) => handleSubmit(e)}
        className=" mx-auto mt-[200px] w-full  max-w-[400px] px-4 "
      >
        <Link
          to="/"
          className="animate flex items-center space-x-1 hover:text-primary"
        >
          <BsArrowLeftShort />
          <Paragraph size="small">retour a l'accueil</Paragraph>
        </Link>
        <span className="font-nunito text-sm text-[#fc3838]">
          {error && error}
        </span>
        <div className=" mt-2 rounded border border-secondary p-5">
          <div>
            <H2>Connexion</H2>
            <Paragraph>
              Connectez vous pour administrer votre boutique
            </Paragraph>
          </div>

          <div className="mt-4">
            <Input
              labelName="E-mail"
              name="mail"
              type="text"
              placeholder="francis@gmail.com"
              value={email}
              onChange={(e) => {
                setError("");
                setEmail(e.target.value);
              }}
            />

            <Input
              labelName="Mot de passe"
              name="password"
              type="password"
              placeholder="********"
              classe="mt-4"
              value={password}
              onChange={(e) => {
                setError("");
                setPassword(e.target.value);
              }}
            />

            <div className="mt-2 flex items-center">
              <Checkbox />
              <Paragraph size="small" classe="text-secondary/50">
                se souvenir de moi
              </Paragraph>
            </div>
          </div>
          <Button size="small" loading={loading} classe="mt-3">
            Connexion
          </Button>
        </div>
      </form>
    </>
  );
};

export default BodyLoginAdmin;
